
import { yandexMap as YandexMap, ymapMarker as YmapMarker } from 'vue-yandex-maps'
import CurrencyRate from '../currency-rate/index.vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

const BANKS_TAG = 'banks'

export default {
  name: 'CurrenciesMap',
  components: {
    YandexMap,
    CurrencyRate,
    YmapMarker
  },
  mixins: [staticBlockMixin],
  data () {
    return {
      currentRegionId: null,
      showPopup: false,
      selectedPointId: null,
      regions: [],
      currencies: []
    }
  },
  async fetch () {
    try {
      const regions = await this.$shops.fetch(BANKS_TAG)

      const currencies =
        JSON.parse(
          JSON.stringify(
            this.$currencies.currenciesGroupedByOffices.officesCurrencies
          ))

      this.bindCurrenciesToRegions(regions, currencies)

      this.currencies = currencies
      this.regions = regions

      const currentSiteName = this.$authNew.sites.find(s => s.id === this.$authNew.siteId)?.name
      this.currentRegionId = this.regions?.find(r => r.name === currentSiteName)?.id

      this.selectPoint(this.region?.shops?.find((shop: any) => shop?.currency?.currenciesInfo)?.id || this.region?.shops?.[0]?.id)
    } catch (error) {
      console.error(error)
    }
  },
  computed: {
    region () {
      return this.regions?.find(region => region.id === this.currentRegionId) || this.regions?.[0]
    },
    selectedPoint () {
      return this.region?.shops?.find(shop => shop.id === this.selectedPointId) || {}
    }
  },
  watch: {
    'region.id' (newValue: number | null) {
      if (!newValue) { return }
      this.selectedPointId = this.region?.shops?.[0]?.id
    },
    '$authNew.siteId' (newSiteId: number) {
      const siteName = this.$authNew.sites?.find(s => s.id === newSiteId)?.name
      const regionId = this.regions?.find(r => r.name === siteName)?.id
      if (regionId) {
        this.currentRegionId = regionId
      }
    }
  },
  methods: {
    selectPoint (id: number) {
      this.selectedPointId = id
    },

    selectRegions (id: number) {
      this.currentRegionId = id
      this.hiddenFilters()
    },

    hiddenFilters () {
      this.showPopup = ''
    },

    bindCurrenciesToRegions (regions: any[], currencies: any[]) {
      const shops = this.extractShopsFromRegions(regions)
      this.bindCurrenciesToShops(shops, currencies)
    },

    bindCurrenciesToShops (shops: any[], currencies: any[]) {
      let temp
      for (const shop of shops) {
        temp = currencies?.find((currency: { code: string }) => currency.code === shop?.params?.officeCode)
        if (!temp) { continue }
        shop.currency = temp
      }
    },

    extractShopsFromRegions (regions: any[]) {
      const shops: any[] = []
      regions.forEach((region: { shops: any[] }) => shops.push(...region.shops))
      return shops
    },

    closeMarkerPopup () {
      this.selectedPointId = null
    }
  }
}
